import { MkIcon } from "@/mk/MkIcon";
import type { ReactNode } from "react";

export function MkField({ label, hint, error, required, className, children }: {
    label?: string;
    hint?: string;
    error?: string;
    required?: boolean;
    className?: string;
    children: ReactNode;
}) {
    return (
        <div className={`mk-field${error ? " mk-field-invalid" : ""}${
            className ? ` ${className}` : ""}`}>
            {(label || hint) && (
                <label className="mk-field-label">
                    <span className="mk-field-label-text">{label}</span>
                    {required && <span className="mk-field-req">*</span>}
                    {hint && (
                        <span className="mk-field-help" tabIndex={0}>
                            <MkIcon name="fa-question-circle" />
                            <span className="mk-field-tip" role="tooltip">{hint}</span>
                        </span>
                    )}
                </label>
            )}
            <div className="mk-field-control">{children}</div>
            {error && (
                <div className="mk-field-msg mk-field-error">
                    <MkIcon name="fa-exclamation-circle" /> <span>{error}</span>
                </div>
            )}
        </div>
    );
}
